const modalOpenBtn = $('.js-modal-trigger');
const modalCloseBtn = $('.js-modal-close');

modalOpenBtn.click(function(){
	let _e = $(this);
	let modalTarget = _e.attr('data-modal-trigger');
	$('#'+modalTarget).toggleClass('is-show');

})

modalCloseBtn.click(function(){
	let _e = $(this);
	_e.closest('.l-modal').removeClass('is-show');
})

